/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import SafeImage from "@/js/components/SafeImage.js";
import { CloseButton } from "@/js/components/shared/CloseButton";
import { useClassroomPolicyStore } from "@/stores/v2/classroomPolicyStore";
import { extractHostname } from "@/js/components/RegularClassroomUser/utils";

export default class StudentTileTabItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isClosed: false,
			unblockOpen: false,
			infoOpen: false,
			blockUserOpen: false,
			isCurrentlyBlocked: useClassroomPolicyStore
				.getState()
				.isCurrentlyBlocked(extractHostname(this.props.item.url), this.props.user.username),
		};
		this.unsubClassroomPolicyStore = () => {};
	}

	componentDidMount() {
		this.unsubClassroomPolicyStore = useClassroomPolicyStore.subscribe(
			(state) => state,
			(newState) => {
				this.onChange(newState);
			}
		);
	}

	componentWillUnmount() {
		this.unsubClassroomPolicyStore();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onChange = (state) => {
		this.setState({
			isCurrentlyBlocked: useClassroomPolicyStore
				.getState()
				.isCurrentlyBlocked(extractHostname(this.props.item.url), this.props.user.username),
		});
	};

	handleClosed = () => {
		this.props.forceCloseTab(this.props.item.tab_id);
		this.setState({
			isClosed: true,
		});
	};

	disableCloseTab = () => {
		return !this.props.item.tab_id || this.state.isClosed || !this.props.classIsActive;
	};

	closeShowInfo = () => {
		this.setState({
			infoOpen: false,
		});
	};

	/**
	 * Opens the Live View modal
	 * @returns {void}
	 */
	openInfoModal = () => {
		if (this.props.isRestricted) return;

		if (this.props.openP2pModal) {
			this.props.openP2pModal(this.props.user, this.props.item.tab_id, this.props.chromeId, this.props.chromeWindowId, false);
			return;
		}

		this.setState({
			infoOpen: true,
		});
	};

	render() {
		const signature = this.props.signatureDb.lookup(this.props.item.title);

		/**
		 * Handles the click event on the tab item
		 * @param {boolean} isMonitorMode - Whether the classroom is in monitor mode
		 * @param {func} openInfoModal - Function to open the info modal
		 * @returns {void}
		 */
		function handleItemClick(isMonitorMode, openInfoModal) {
			if (isMonitorMode) return;
			openInfoModal();
		}

		return (
			<div
				className={clsx(
					!this.state.isClosed ? "FastWindowTabItem" : "FastWindowTabItem--closed",
					this.props.isRestricted && "FastWindowTabItem--NoClick"
				)}
			>
				<div className="FastWindowTabItem_titleContainer">
					<SafeImage
						styleClassName={clsx(
							this.props.isMonitorMode ? "tab-favicon--noInteract FastWindowTabItem_icon--noInteract" : "tab-favicon FastWindowTabItem_icon"
						)}
						src={this.props.item.favicon}
						onClick={() => handleItemClick(this.props.isMonitorMode, this.openInfoModal)}
					/>
					<span
						className={this.props.isMonitorMode ? "FastWindowTabItem_title--noInteract" : "FastWindowTabItem_title"}
						onClick={() => handleItemClick(this.props.isMonitorMode, this.openInfoModal)}
						title={signature}
					>
						{signature}
					</span>
				</div>
				{this.props.canCloseTab && (
					<>
						<CloseButton
							tooltipText="Close Tab"
							tooltipId={this.props.item.tab_id + "_closeTabTooltip"}
							disabled={this.disableCloseTab()}
							onClick={() => this.handleClosed()}
						/>
					</>
				)}
			</div>
		);
	}
}

StudentTileTabItem.propTypes = {
	user: PropTypes.object,
	item: PropTypes.object,
	forceCloseTab: PropTypes.func,
	canCloseTab: PropTypes.bool,
	classIsActive: PropTypes.bool,
	signatureDb: PropTypes.object,
	isActiveTab: PropTypes.bool,
	isMonitorMode: PropTypes.bool,
	openP2pModal: PropTypes.func,
	/**
	 * Is the teacher currently restricted from seeing the screen based on the domain or app in view? (via Screen Visibility Restrictions)
	 */
	isRestricted: PropTypes.bool,
};
